import { render, staticRenderFns } from "./Table.vue?vue&type=template&id=2f2641f6&"
import script from "./Table.js?vue&type=script&lang=js&"
export * from "./Table.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tempos21/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2f2641f6', component.options)
    } else {
      api.reload('2f2641f6', component.options)
    }
    module.hot.accept("./Table.vue?vue&type=template&id=2f2641f6&", function () {
      api.rerender('2f2641f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modules/Table/Table.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/Table/Table.vue
// module id = cm7W
// module chunks = 0